import { db } from "../firebase/config";
import getAccess from "./getAccess";

const lookupTicket = async (email: string, code: string) => {
  const ticketRef = await db.collection("tickets").get();

  const tickets = await Promise.all(
    ticketRef.docs.map((doc) => {
      const data = doc.data();
      const {
        email,
        code,
        code2,
        firstname,
        lastname,
        type,
        order,
        status,
      } = data;

      return {
        email,
        code,
        code2,
        firstname,
        lastname,
        type,
        order,
        status,
        access: getAccess(data.type),
      };
    })
  );

  const ticket = tickets.find(
    (ticket) =>
      ticket.email.toLowerCase() === email.toLowerCase() &&
      (ticket.code.toString().toLowerCase() === code.toString().toLowerCase() ||
        (ticket.code2 &&
          ticket.code2.toString().toLowerCase() ===
            code.toString().toLowerCase())) &&
      ticket.status === "active"
  );

  return ticket;
};

export default lookupTicket;
